// extracted by mini-css-extract-plugin
module.exports = {"holder":"holder_2CgC9","container":"container_1pdM1","fixFont":"fixFont_BXCSf"};